import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
export default class ReceiveGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,

      filter_search: "",
      filter_product_id: "",

      data_warehouse: [],
      data_company: [],
      data_product: [],
      data_category: [],

      // stock
      document_no: "",
      type: "",
      name: "",
      date: format_date(new Date(), "yyyy-mm-dd", "en"),
      start_date: "",
      end_date: "",
      count_item: "",
      ref_number: "",
      activity_type: "รับจากบริษัทจำหน่าย",
      customer_id: "",
      supplier_id: "",
      warehouse_id: "",
      destination_warehouse_id: "",
      user_id: "",
      amount: "",
      discount: "",
      vat: "",
      amount_net: "",
      cause: "",
      status: "",
      remark: "",
      transaction_list: [],

      // สินค้า
      product_photo: "",
      product_warehouse_id: "",
      product_name: "",
      product_category_id: "",
      product_is_serial_number: false,
      product_unit_name: "",
      product_sale_price: "",
      product_cost_price: "",
      product_description: "",

      is_vat: false,
      delivery_cost: "",
    };
  }

  async componentDidMount() {
    loading(true);
    await this.Get();
    if (params("uid")) {
      await this.GetByID(params("uid"));
    }
    loading(false);
  }
  Get = async () => {
    let data_user, data_product, data_warehouse, data_category, data_company;
    let [
      result_user,
      result_product,
      result_warehouse,
      result_category,
      result_company,
    ] = await Promise.all([
      GET("admin/setting/users/list", { page: 0, data_search: "" }),
      GET("admin/setting/spare-parts/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
      GET("admin/setting/companies/list", { page: 0, data_search: "" }),
    ]);
    if (result_user?.status) {
      data_user = result_user.data.map((e) => ({
        value: e.uid,
        label: e.full_name,
      }));
    }
    if (result_product?.status) {
      data_product = result_product.data.map((e) => ({
        value: e.uid,
        label: `${e.product_code} ${e.product_name}`,
        id: e.id,
        warehouse_id: e.warehouse?.uid || "",
        unit_name: e.unit_name,
        is_serial_number: e.is_serial_number,
        product_code: e.product_code,
        product_name: e.product_name,
        sale_price: e.sale_price,
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_category?.status) {
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse?.uid,
      }));
    }
    if (result_company?.status) {
      data_company = result_company.data.map((e) => ({
        value: e.uid,
        label: e.company_name,
        warehouse_id: e.warehouse?.uid,
      }));
    }
    this.setState({
      data_user,
      data_product,
      data_warehouse,
      data_category,
      data_company,
    });
  };
GetProduct = async () => {
   const result_product = await GET("admin/setting/spare-parts/list", { page: 0, data_search: "" });
if (result_product?.status) {
      this.setState({data_product:result_product.data.map((e) => ({
        value: e.uid,
        label: `${e.product_code} ${e.product_name}`,
        id: e.id,
        warehouse_id: e.warehouse?.uid || "",
        unit_name: e.unit_name,
        is_serial_number: e.is_serial_number,
        product_code: e.product_code,
        product_name: e.product_name,
        sale_price: e.sale_price,
      }))
      });
    }
  }
  GetByID = async (uid) => {
    const { data_product } = this.state;
    let result = await GET("admin/stock-activities/list", { uid });
    this.setState(
      {
        ...result.data,
        supplier_id: result.data?.supplier?.uid,
        warehouse_id: result.data?.warehouse?.uid,
        transaction_list: result.data?.transaction_list?.map((e) => ({
          ...e,
          product_id:
            data_product.find((p) => p.product_code === e.product_code)
              ?.value || "",
        })),
      },
      () => {
        let input = document.querySelectorAll("input,textarea,select");
        for (let item of input) {
          item.disabled = true;
        }
      }
    );
  };

  CreateUpdate = async (_status) => {
    const {
      data_product,
      id,
      uid,
      data,
      document_no,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,
      is_vat,
      delivery_cost,
    } = this.state;
    if (!date?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกวันที่รับสินค้า");
      return;
    } else if (!warehouse_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
      return;
    } else if (!activity_type?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการรับ");
      return;
    } else if (!supplier_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกบริษัทจำหน่าย");
      return;
    }

    loading(true);
    const vatRate = is_vat ? 0.07 : 0;

    let _amount = 0;
    let serial = false;
    transaction_list.forEach((item) => {
      const qty = Number(item.qty ?? 0);
      const unitPrice = Number(item.unit_price ?? 0);
      const itemDiscount = Number(item.discount ?? 0);
      _amount += qty * (unitPrice - itemDiscount);
      item.serial_number = item.serial_number
        .toString()
        .split(",")
        .filter((e) => e);
      if (
        item.serial_number.length !== qty &&
        data_product.find((e) => e.value === item.product_id)?.is_serial_number
      ) {
        serial = true;
      }
    });
    if (serial) {
      loading(false);
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        "จำนวน Serial Number กับ จำนวนสินค้าบางรายการไม่ตรงกัน"
      );
      return;
    }

    if (isNaN(_amount)) _amount = 0;

    const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
    const net = _amount - billDiscount;

    const _vat = net * vatRate;
    const _amount_net = net + net * vatRate + Number(delivery_cost);
    let body = {
      type: "รับสินค้า",
      name,
      date,
      start_date,
      end_date,
      count_item: transaction_list.length,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount: Number(_amount),
      discount: Number(discount),
      vat: Number(_vat),
      delivery_cost: Number(delivery_cost),
      amount_net: Number(_amount_net),
      cause,
      status: _status || "เสร็จสิ้น",
      remark,
      transaction_list,
      is_vat,
    };

    let result = !uid
      ? await POST("admin/stock-activities/create", body)
      : await PUT("admin/stock-activities/update/" + uid, body);
    if (result?.status) {
      alert("/stock/receive-goods/create", "success");
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  CreateProduct = async () => {
    const {
      product_photo,
      product_warehouse_id,
      product_name,
      product_code,
      product_category_id,
      product_is_serial_number,
      product_serial_number,
      product_unit_name,
      product_sale_price,
      product_cost_price,
      product_description,
    } = this.state;
    if (!product_warehouse_id.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
      return;
    } else if (!product_name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อสินค้า");
      return;
    }

    loading(true);
    let body = {
      photo: product_photo,
      warehouse_id: product_warehouse_id,
      product_name,
      product_type: "อะไหล่",
      product_code,
      category_id: product_category_id,
      is_serial_number: product_is_serial_number,
      serial_number: product_serial_number,
      unit_name: product_unit_name,
      sale_price: Number(product_sale_price),
      cost_price: Number(product_cost_price),
      product_description,
    };

    let result = await POST("admin/setting/spare-parts/create", body);
    if (result?.status) {
      let data_product;
      let [result_product] = await Promise.all([
        GET("admin/setting/spare-parts/list", { page: 0, data_search: "" }),
      ]);
      if (result_product?.status) {
        data_product = result_product.data.map((e) => ({
          value: e.uid,
          label: `${e.product_code} ${e.product_name}`,
          id: e.id,
          warehouse_id: e.warehouse?.uid || "",
          unit_name: e.unit_name,
          is_serial_number: e.is_serial_number,
          product_code: e.product_code,
          product_name: e.product_name,
          sale_price: e.sale_price
        }));
      }
      this.setState({ data_product, modal_create: false });
      alert("","success","สำเร็จ","เพิ่มสินค้าเรียบร้อย")
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  render() {
    const {
      modal_create,

      filter_search,
      filter_product_id,

      data,
      data_warehouse,
      data_company,
      data_product,
      data_category,

      // stock
      document_no,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,

      // สินค้า
      product_photo,
      product_warehouse_id,
      product_name,
      product_category_id,
      product_is_serial_number,
      product_unit_name,
      product_sale_price,
      product_cost_price,
      product_description,

      is_vat,
      delivery_cost,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รับสินค้า</h4>
              <button
                className="btn btn-outline-dark px-3 ms-auto mb-2 banks.create"
                onClick={async () => {
                  window.location.href = "/stock/receive-goods";
                }}
              >
                ย้อนกลับ
              </button>
            </div>
            <div className="row mb-3">
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เลขที่เอกสาร</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เลขที่เอกสาร..."
                  onChange={(e) => {
                    this.setState({ document_no: e.target.value });
                  }}
                  value={document_no}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">วันที่รับสินค้า{required}</div>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ date: e.target.value });
                  }}
                  value={date}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">คลังสินค้า{required}</div>
                <Select
                  className="form-control"
                  placeholder="เลือกคลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ warehouse_id: e });
                  }}
                  value={warehouse_id}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ประเภทการรับ{required}</div>
                <Select
                  className="form-control"
                  placeholder="เลือกประเภทการรับ..."
                  options={[
                    "รับจากบริษัทจำหน่าย",
                    "รับโอนจากสาขาอื่น",
                    "รับคืนจากลูกค้า",
                  ].map((e) => ({ value: e, label: e }))}
                  onChange={(e) => {
                    this.setState({ activity_type: e });
                  }}
                  value={activity_type}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">บริษัทจำหน่าย{required}</div>
                <Select
                  className="form-control"
                  placeholder="เลือกบริษัทจำหน่าย..."
                  options={data_company.filter(
                    (e) => warehouse_id && e.warehouse_id === warehouse_id
                  )}
                  onChange={(e) => {
                    this.setState({ supplier_id: e });
                  }}
                  value={supplier_id}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เลขที่อ้างอิง PO</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เลขที่อ้างอิง PO..."
                  onChange={(e) => {
                    this.setState({ ref_number: e.target.value });
                  }}
                  value={ref_number}
                />
              </div>
            </div>
          </div>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="d-flex flex-wrap">
              {/* <Select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหาสินค้า..."
                options={data_product}
                onChange={(e) => {
                  this.setState({ filter_product_id: e.target.value });
                }}
                value={filter_product_id}
              /> */}
              {!params("uid") && (
                <div className="d-flex">
                  <button
                    className="btn btn-dark px-3 me-2 mb-2"
                    onClick={() => {
                      this.setState(
                        {
                          transaction_list: [
                            ...this.state.transaction_list,
                            {
                              uid: "",
                              type: "",
                              product_id: "",
                              product_name: "",
                              product_code: "",
                              product_type: "",
                              serial_number: "",
                              warehouse_id: "",
                              warehouse_name: "",
                              category_id: "",
                              category_name: "",
                              qty: 1,
                              unit_name: "",
                              cause: "",
                              discount: "",
                              sale_price: "",
                              cost_price: "",
                              unit_price: "",
                              amount: "",
                            },
                          ],
                        },
                        () => {
                          try {
                            const index =
                              this.state.transaction_list.length - 1;
                            document.getElementById("price-" + index)?.focus();
                          } catch (e) {
                            console.error(
                              "Error focusing on product input:",
                              e
                            );
                          }
                        }
                      );
                    }}
                  >
                    เพิ่มรายการ
                  </button>
                </div>
              )}
              <button
                className="btn btn-dark px-3 me-2 mb-2"
                onClick={() => {
                  this.setState({
                    product_photo: "",
                    product_warehouse_id: "",
                    product_name: "",
                    product_code: "",
                    product_category_id: "",
                    product_is_serial_number: false,
                    product_serial_number: "",
                    product_unit_name: "",
                    product_sale_price: "",
                    product_cost_price: "",
                    product_description: "",
                    modal_create: true,
                  });
                }}
              >
                เพิ่มสินค้า
              </button>
            </div>
            <div>
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap">Serial No.</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-center">ราคา/หน่วย</td>
                    <td className="text-nowrap text-center">ส่วนลด</td>
                    <td className="text-nowrap text-end">ราคาหลังหักส่วนลด</td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_list?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">
                        <Select
                          className="form-control"
                          placeholder="ค้นหาสินค้า..."
                          options={data_product.filter(
                            (e) =>
                              warehouse_id && e.warehouse_id === warehouse_id
                          )}
                          onChange={(e, i) => {
                            transaction_list[index].product_id = e;
                            transaction_list[index].product_code =
                              i.product_code;
                            transaction_list[index].product_name =
                              i.product_name;
                            transaction_list[index].unit_name = i.unit_name;
                            transaction_list[index].serial_number = "";
                            this.setState({ transaction_list });
                            this.GetProduct();
                          }}
                          value={item.product_id}
                        />
                      </td>
                      <td className="text-nowrap">
                        {data_product.find((e) => e.value === item.product_id)
                          ?.is_serial_number && (
                          <input
                            type="text"
                            className="form-control mx-1"
                            onChange={(e) => {
                              transaction_list[index].serial_number =
                                e.target.value;
                              this.setState({ transaction_list });
                            }}
                            value={item.serial_number}
                          />
                        )}
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex">
                          {!params("uid") && (
                            <button
                              className="btn btn-primary wpx-30"
                              onClick={async () => {
                                if (item.qty <= 1) {
                                  if (
                                    await alert(
                                      "",
                                      "info",
                                      "ยืนยัน",
                                      "ยืนยันการลบข้อมูลนี้หรือไม่",
                                      "ลบข้อมูล",
                                      "ยกเลิก"
                                    )
                                  ) {
                                    this.setState({
                                      transaction_list: transaction_list.filter(
                                        (_, i) => i !== index
                                      ),
                                    });
                                  }
                                } else {
                                  transaction_list[index].qty = Math.max(
                                    0,
                                    item.qty - 1
                                  );
                                  this.setState({ transaction_list });
                                }
                              }}
                            >
                              -
                            </button>
                          )}
                          <input
                            type="text"
                            className="form-control wpx-60 mx-1 text-center"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_list[index].qty = Number(
                                e.target.value
                              );
                              this.setState({ transaction_list });
                            }}
                            value={item.qty}
                          />
                          {!params("uid") && (
                            <button
                              className="btn btn-primary wpx-30"
                              onClick={() => {
                                transaction_list[index].qty = Math.max(
                                  0,
                                  item.qty + 1
                                );
                                this.setState({ transaction_list });
                              }}
                            >
                              +
                            </button>
                          )}
                        </div>
                      </td>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control wpx-100 mx-1 text-end"
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            transaction_list[index].unit_price = e.target.value;
                            transaction_list[index].cost_price = e.target.value;
                            this.setState({ transaction_list });
                          }}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") {
                              if (index === transaction_list.length - 1) {
                                this.setState(
                                  {
                                    transaction_list: [
                                      ...transaction_list,
                                      {
                                        uid: "",
                                        type: "",
                                        product_id: "",
                                        product_name: "",
                                        product_code: "",
                                        product_type: "",
                                        serial_number: "",
                                        warehouse_id: "",
                                        warehouse_name: "",
                                        category_id: "",
                                        category_name: "",
                                        qty: 1,
                                        unit_name: "",
                                        cause: "",
                                        discount: "",
                                        sale_price: "",
                                        cost_price: "",
                                        unit_price: "",
                                        amount: "",
                                      },
                                    ],
                                  },

                                  () => {
                                    try {
                                      const index =
                                        this.state.transaction_list.length - 1;
                                      document
                                        .getElementById("price-" + index)
                                        ?.focus();
                                    } catch (e) {
                                      console.error(
                                        "Error focusing on product input:",
                                        e
                                      );
                                    }
                                  }
                                );
                              } else {
                                try {
                                  document
                                    .getElementById("price-" + (index + 1))
                                    .focus();
                                } catch (e) {
                                  console.error(
                                    "Error focusing on product input:",
                                    e
                                  );
                                }
                              }
                            }
                          }}
                          value={item.unit_price}
                          id={`price-${index}`}
                        />
                      </td>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control wpx-100 mx-1 text-end"
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            transaction_list[index].discount = e.target.value;
                            this.setState({ transaction_list });
                          }}
                          value={item.discount}
                        />
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          Number(item.unit_price) - Number(item.discount)
                        ) || "0.00"}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          Number(item.qty) *
                            (Number(item.unit_price) - Number(item.discount))
                        ) || "0.00"}
                      </td>
                      <td className="text-center align-middle wpx-100">
                        {!params("uid") && (
                          <div className="d-flex">
                            <BtnIcon
                              className="receive-goods.delete"
                              type="delete"
                              onClick={async () => {
                                if (
                                  await alert(
                                    "",
                                    "info",
                                    "ยืนยัน",
                                    "ยืนยันการลบข้อมูลนี้หรือไม่",
                                    "ลบข้อมูล",
                                    "ยกเลิก"
                                  )
                                ) {
                                  this.setState({
                                    transaction_list: transaction_list.filter(
                                      (_, i) => i !== index
                                    ),
                                  });
                                }
                              }}
                            />
                            <BtnIcon
                              className="receive-goods.update"
                              type="print"
                              onClick={() => {
                                window.open(
                                  `/pdf/barcode?uid=&product_code=${
                                    item.product_code
                                  }&product_name=${
                                    item.product_name
                                  }&serial_number=${
                                    item.serial_number
                                  }&sale_price=${
                                    data_product.find(
                                      (p) =>
                                        p.product_code === item.product_code
                                    )?.sale_price
                                  }`
                                );
                              }}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row mb-3">
              <div className="col-12 col-md-6 mb-2">
                <div className="wpx-150 mb-1">หมายเหตุ</div>
                <textarea
                  className="form-control"
                  placeholder="กรอกหมายเหตุ(ถ้ามี)..."
                  rows={10}
                  onChange={(e) => {
                    this.setState({ remark: e.target.value });
                  }}
                  value={remark}
                />
              </div>
              <div className="col-12 col-md-6 mb-2">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <b>รวมเป็นเงิน</b>
                  <span>
                    {(() => {
                      let total = 0;
                      transaction_list.forEach((item) => {
                        total +=
                          Number(item.qty) *
                          (Number(item.unit_price) - Number(item.discount));
                      });
                      if (isNaN(total)) total = 0;
                      return `${toFixed(total || 0)} บาท`;
                    })()}
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <b>ส่วนลด</b>
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control wpx-200 me-2 text-end"
                      placeholder="0.00"
                      onChange={(e) => {
                        if (!float(e.target.value)) return;
                        this.setState({ discount: e.target.value });
                      }}
                      value={discount}
                    />
                    <span>บาท</span>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <b>ราคาหลังหักส่วนลด</b>
                  <span>
                    {(() => {
                      let total = 0;
                      transaction_list.forEach((item) => {
                        total +=
                          Number(item.qty) *
                          (Number(item.unit_price) - Number(item.discount));
                      });
                      if (isNaN(total)) total = 0;
                      return `${toFixed(total - discount || 0)} บาท`;
                    })()}{" "}
                    บาท
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center">
                    <b>ภาษีมูลค่าเพิ่ม 7%</b>{" "}
                    <Switch
                      className="ms-3"
                      onChange={(e) => {
                        this.setState({ is_vat: e });
                      }}
                      checked={is_vat}
                      disabled={params("uid")}
                    />
                  </div>
                  <span>
                    {(() => {
                      let total = 0;
                      const vatRate = is_vat ? 0.07 : 0;

                      transaction_list.forEach((item) => {
                        const qty = Number(item.qty ?? 0);
                        const unitPrice = Number(item.unit_price ?? 0);
                        const itemDiscount = Number(item.discount ?? 0);
                        total += qty * (unitPrice - itemDiscount);
                      });

                      if (isNaN(total)) total = 0;

                      const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                      const net = total - billDiscount;

                      const vat = net * vatRate;

                      return `${toFixed(vat)} บาท`;
                    })()}
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <b>ค่าส่ง</b>
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control wpx-200 me-2 text-end"
                      placeholder="0.00"
                      onChange={(e) => {
                        if (!float(e.target.value)) return;
                        this.setState({ delivery_cost: e.target.value });
                      }}
                      value={delivery_cost}
                    />
                    <span>บาท</span>
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <b>จำนวนเงินรวมทั้งหมด</b>
                  <h4 className="fw-bold text-success">
                    {(() => {
                      let total = 0;
                      const vatRate = is_vat ? 0.07 : 0;

                      transaction_list.forEach((item) => {
                        const qty = Number(item.qty ?? 0);
                        const unitPrice = Number(item.unit_price ?? 0);
                        const itemDiscount = Number(item.discount ?? 0);
                        total += qty * (unitPrice - itemDiscount);
                      });

                      if (isNaN(total)) total = 0;

                      const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                      const net = total - billDiscount;

                      const vat = net * vatRate;
                      const grandTotal = net + vat + Number(delivery_cost);

                      return `${toFixed(grandTotal)} บาท`;
                    })()}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          {!params("uid") && (
            <div className="pt-0 border-0 d-flex justify-content-end">
              <div className="d-flex">
                <button
                  className="btn btn-dark px-5 me-1"
                  onClick={async () => {
                    this.CreateUpdate("เสร็จสิ้น");
                  }}
                >
                  บันทึกการรับสินค้า
                </button>
              </div>
            </div>
          )}
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create}
          onHide={() => this.setState({ modal_create: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เพิ่มอะไหล่</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-2">
              <div className="wpx-150 mt-2">รูปภาพ</div>
              <div className="d-flex flex-wrap">
                <input
                  hidden
                  accept="image/*"
                  id="image"
                  type="file"
                  onChange={async (e) => {
                    if (e.target.files[0]) {
                      let image = await new Promise((resolve) => {
                        Resizer.imageFileResizer(
                          e.target.files[0],
                          1200,
                          1200,
                          "JPEG",
                          100,
                          0,
                          (uri) => {
                            resolve(uri);
                          },
                          "base64"
                        );
                      });
                      this.setState({ product_photo: image });
                      e.target.value = "";
                    }
                  }}
                />
                {this.state.product_photo ? (
                  <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                    <img
                      alt="example"
                      src={this.state.product_photo}
                      className="rounded-3"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <span
                      className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-16 position-absolute icon d-flex align-items-center justify-content-center shadow"
                      style={{ right: -8, top: -8 }}
                      onClick={() => {
                        this.setState({ product_photo: "" });
                      }}
                    >
                      {"\uf00d"}
                    </span>
                  </div>
                ) : (
                  <div className="d-flex">
                    <div
                      className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-32 text-success bg-success-light rounded-3 pointer"
                      onClick={() => {
                        document.getElementById("image").click();
                      }}
                    >
                      {"\uf03e"}
                    </div>
                    <small className="text-secondary ps-3">
                      <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล
                      เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                      <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF <br />
                      <b>ขนาดไฟล์สูงสุด:</b> 5MB
                    </small>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">คลังสินค้า{required}</div>
              <Select
                className="form-control"
                placeholder="คลังสินค้า..."
                options={data_warehouse}
                onChange={(e) => {
                  this.setState({ product_warehouse_id: e });
                }}
                value={product_warehouse_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อสินค้า{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อสินค้า..."
                onChange={(e) => {
                  this.setState({ product_name: e.target.value });
                }}
                value={product_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">หมวดหมู่{required}</div>
              <Select
                className="form-control"
                placeholder="หมวดหมู่..."
                options={data_category.filter(
                  (e) => e.warehouse_id === product_warehouse_id
                )}
                onChange={(e) => {
                  this.setState({ product_category_id: e });
                }}
                value={product_category_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">Serial number</div>
              <div className="d-flex align-items-center w-100">
                <Switch
                  className="me-3"
                  onChange={(e) => {
                    this.setState({
                      product_is_serial_number: e,
                      serial_number: "",
                    });
                  }}
                  checked={product_is_serial_number}
                />
              </div>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">หน่วยนับ</div>
              <Select
                className="form-control"
                placeholder="หน่วยนับ..."
                options={[
                  "ตัว",
                  "ลูก",
                  "คู่",
                  "ชุด",
                  "เส้น",
                  "ข้าง",
                  "ชิ้น",
                  "เมตร",
                  "ม้วน",
                  "แผ่น",
                  "บาน",
                  "กล่อง",
                  "เครื่อง",
                  "ดวง",
                  "อัน",
                ].map((e) => ({ value: e, label: e }))}
                onChange={(e) => {
                  this.setState({ product_unit_name: e });
                }}
                value={product_unit_name}
              >
                <option value=""></option>
              </Select>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ราคาขาย</div>
              <input
                type="text"
                className="form-control"
                placeholder="ราคาขาย..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ product_sale_price: e.target.value });
                }}
                value={product_sale_price}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ราคาต้นทุน</div>
              <input
                type="text"
                className="form-control"
                placeholder="ราคาต้นทุน..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ product_cost_price: e.target.value });
                }}
                value={product_cost_price}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">รายละเอียด</div>
              <textarea
                className="form-control"
                placeholder="รายละเอียด..."
                rows={5}
                onChange={(e) => {
                  this.setState({ product_description: e.target.value });
                }}
                value={product_description}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateProduct();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
